export const populateTemplate = (templateString, data) => {
  let populatedString = templateString;
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const regex = new RegExp(`{{\\.${key}}}`, "g");
      populatedString = populatedString.replace(regex, data[key]);
    }
  }
  return populatedString;
};

export const onlyContainsNumbers = (str) => /^[0-9,.]*$/.test(str);